<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <div class="finance-header">
        <span class="finance-span">
          <label>收付款编号:</label>
          <vxe-input
              v-model="paymentsNum"
              @keyup.enter.native="search"
              placeholder="请输入收付款编号"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>付款人名称:</label>
          <vxe-input
              v-model="fromSubjectName"
              @keyup.enter.native="search"
              placeholder="请输入付款人名称"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>收款人名称:</label>
          <vxe-input
              v-model="toSubjectName"
              @keyup.enter.native="search"
              placeholder="请输入收款人名称"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>子订单号:</label>
          <vxe-input
              v-model="orderNum"
              @keyup.enter.native="search"
              placeholder="请输入会员名称"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>状态筛选:</label>
          <Select
              v-model="proState"
              style="width: 200px"
              placeholder="请选择状态类型"
          >
            <Option
                v-for="item in stateOptions"
                :value="item.value"
                :key="item.value"
            >{{ item.label }}</Option
            >
          </Select>
        </span>
      </div>
      <div class="finance-header" style="display: flex">
         <span class="finance-span finance-span-time">
          <label>选择时间:</label>
          <DatePicker
              type="date"
              v-model="startTime"
              placeholder="请选择开始日期"
              style="width: 200px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
              type="date"
              v-model="endTime"
              placeholder="请选择结束日期"
              style="width: 200px"
          ></DatePicker>
        </span>
        <span class="finance-span">
          <label>创建人:</label>
          <vxe-input
              v-model="createUser"
              @keyup.enter.native="search"
              placeholder="请输入创建人"
              clearable
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <Button type="primary" icon="ios-search" @click="search" style="border-radius: 5px;">搜索 </Button>
          <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置 </Button>
          <Button type="primary" @click="download" style="margin-left: 10px;border-radius: 5px">明细导出</Button>
        </span>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          show-overflow
          keep-source
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="dataList"
          :footer-method="footerMethod"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="60">
        </vxe-table-column>
        <vxe-table-column field="paymentsNum" title="收付款编号" width="150">
          <template slot-scope="{ row }">
            <span @click="viewDetail(row)" style="color: #2D8CF0;cursor:pointer">{{ row.paymentsNum }}</span>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="orderNum" width="120" title="子订单编号">-->
        <!--        </vxe-table-column>-->
        <vxe-table-column field="createTime" width="160" title="时间">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDateTime }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="note"
            width="180"
            title="摘要"
        ></vxe-table-column>
        <vxe-table-column field="amount" width="200" title="金额（元）">
          <template slot-scope="{ row }">
            <span>{{ row.amount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="fromSubjectName" width="200" title="付款方">
        </vxe-table-column>
        <vxe-table-column field="toSubjectName" width="200" title="收款方">
        </vxe-table-column>
        <vxe-table-column field="proState" width="100" title="付款状态">
          <template slot-scope="{ row }">
            <span>{{ row.proState | proStateToName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="errorInfo" title="失败原因" width="150"
        ></vxe-table-column>
        <vxe-table-column field="createUser" min-width="80" title="创建人"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="140">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDateTime }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
          :footer-method="footerMethod"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="isShowPaymentDetail" width="1450" height="680" resize remember>
      <div slot="title">收付款详情</div>
      <payment-detail :cate="cate" :isShow="isShowPaymentDetail" ref="paymentDetail"
                      @close="isShowPaymentDetail = false"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal v-model="isShowPaymentDetailTwo" width="1450" height="680" resize remember>
      <div slot="title">收付款详情</div>
      <payment-detail-two :cate="cate" :isShow="isShowPaymentDetailTwo" ref="paymentDetailTwo"
                      @close="isShowPaymentDetailTwo = false"
      ></payment-detail-two>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import moment from 'moment'
import PaymentDetail from '@/views/payment/PaymentDetail.vue';
import PaymentDetailTwo from '@/views/payment2.0/PaymentDetail.vue';
import {commonFooter, getBlob, hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";

moment.locale('zh-CN')

export default {
  components: {PaymentDetail,PaymentDetailTwo},
  name: "TradeList",
  data() {
    return {
      loading: false,
      dataList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      // -1银行无记录  0-成功,   6-未知  7-无效  8-未处理   9-失败
      stateOptions: [
        {label: "成功", value: "0000"},
        {label: "未知", value: "6666"},
        {label: "无效", value: "7777"},
        {label: "未处理", value: "8888"},
        {label: "失败", value: "9999"},
        {label: "银行无记录", value: "-1"},
      ],
      paymentsNum: null,
      fromSubjectName: null,
      toSubjectName: null,
      orderNum: null,
      proState: null,
      startTime: '',
      endTime: '',
      searchObj: {},
      isShowPaymentDetail: false,
      isShowPaymentDetailTwo:false,
      cate: 'Payment',
      createUser: null,
      countRtnVo: {},
      paramsObj: {},
    };
  },
  mounted() {
    this.$bus.$on("线上付款明细", () => {
      this.reset();
      this.startTime = moment().startOf("day").format("YYYY-MM-DD 00:00:00");
      this.endTime = moment().endOf('day').format("YYYY-MM-DD 23:59:59");
    });
    this.startTime = moment().startOf("day").format("YYYY-MM-DD 00:00:00")
    this.endTime = moment().endOf('day').format("YYYY-MM-DD 23:59:59")
  },
  methods: {
    viewDetail(row) {
      if (row.orderVersion != null && row.orderVersion == 2){
        this.isShowPaymentDetailTwo = true;
        this.$refs.paymentDetailTwo.setEdit(false);
        this.$refs.paymentDetailTwo.init(row.paymentsId);
      }
      else {
        this.isShowPaymentDetail = true;
        this.$refs.paymentDetail.setEdit(false);
        this.$refs.paymentDetail.init(row.paymentsId);
      }


    },
    reset() {
      this.paymentsNum = null;
      this.fromSubjectName = null;
      this.toSubjectName = null;
      this.orderNum = null;
      this.proState = null;
      this.startTime = '';
      this.endTime = '';
      this.page.currentPage = 1;
      this.dataList = []
      this.createUser = null
    },
    search() {
      if (this.endTime === '' && this.startTime === '' && !this.paymentsNum && !this.fromSubjectName && !this.toSubjectName && !this.orderNum && !this.proState) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return
      }
      let searchObj = {};
      this.page.currentPage = 1;
      searchObj.paymentsNum = this.paymentsNum;
      searchObj.fromSubjectName = this.fromSubjectName;
      searchObj.toSubjectName = this.toSubjectName;
      searchObj.orderNum = this.orderNum;
      searchObj.proState = this.proState;
      searchObj.startTime = this.startTime === '' ? this.startTime : this.$utils.timestamp(this.startTime);
      searchObj.endTime = this.endTime === '' ? this.endTime : (this.$utils.timestamp(this.endTime) + 86399000);
      searchObj.createUser = this.createUser
      this.searchObj = searchObj
      this.getTradeList(searchObj);
    },
    refresh() {
      this.search()
    },
    footerMethod({columns, data}) {
      return commonFooter({columns, data, fields: ['amount'], countRtnVo: this.countRtnVo});
    },
    handlePageChange(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.getTradeList(this.searchObj);
    },
    getTradeList(searchObj = {}) {
      let obj = {};
      obj.page = this.page.currentPage;
      obj.rows = this.page.pageSize;
      obj.orderBy = 2;
      this.loading = true;
      this.paramsObj = Object.assign(obj, searchObj);
      $api.finance.getTradeListModel
          .POST({
            data: this.paramsObj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.dataList = res.data.rows;
              this.page.totalResult = res.data.total;
              this.countRtnVo = JSON.parse(res.data.countData)
              this.loading = false;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    async download() {
      if (isEmpty(this.dataList)) {
        this.$XModal.message("请先搜索数据");
        return;
      }
      showLoading();
      let res = postBlob("/api/finance/cebTradeExport/exportTradeList", this.paramsObj);
      hideLoading();
      await saveBlob("明细导出.xls", res.data);
    },
  },
};
</script>

<style>
.finance-header .finance-span {
  display: inline-block;
  padding-right: 10px;
  margin-bottom: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 52px;
  text-align: center;
}

.finance-header label {
  display: inline-block;
  padding: 0 5px;
  color: #999;
}

.finance-header .vxe-input--inner,
.finance-header .ivu-input,
.finance-header .ivu-select-selection {
  border-radius: 0;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.finance-header .ivu-select {
  width: 320px;
  height: 34px;
  overflow: hidden;
}

.finance-header .ivu-select-multiple .ivu-tag,
.finance-header .ivu-select-input {
  display: inline-block;
  float: left;
}

.finance-header .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 0;
}

.finance-header .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}

.ceb-sel-link {
  display: block;
  width: 100%;
  height: 34px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 0.6em;
}
</style>
